export default __webpack_public_path__ + "acbe3c4706c462d42f501bb574c591b6.png";